"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _has = _interopRequireDefault(require("lodash/has"));

var _react = require("react");

var _compact = _interopRequireDefault(require("lodash/compact"));

var _useTranslations = _interopRequireDefault(require("../../../../utils/useTranslations"));

var _utils = require("../../utils");

var _useMonth2 = _interopRequireDefault(require("../useMonth"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function monthDiff(dateFrom, dateTo) {
  var sign = dateFrom < dateTo ? 1 : -1;
  var earlyDate = dateFrom < dateTo ? dateFrom : dateTo;
  var lateDate = earlyDate === dateFrom ? dateTo : dateFrom;
  return sign * (lateDate.getMonth() - earlyDate.getMonth() + 12 * (lateDate.getFullYear() - earlyDate.getFullYear()));
}

function useCalendar() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$date = options.date,
      date = _options$date === void 0 ? new Date() : _options$date;

  var _useState = (0, _react.useState)({
    monthOffset: 0,
    selected: options.selected || options.defaultSelected || undefined
  }),
      _useState2 = _slicedToArray(_useState, 2),
      useCalendarState = _useState2[0],
      setUseCalendarState = _useState2[1];

  var currentActiveDate = useCalendarState.currentActiveDate,
      monthOffset = useCalendarState.monthOffset,
      selected = useCalendarState.selected,
      clickedDate = useCalendarState.clickedDate;
  var updateCalendarState = (0, _react.useCallback)(function (updates) {
    setUseCalendarState(function (previousState) {
      return _objectSpread({}, previousState, {}, updates);
    });
  }, [setUseCalendarState]);
  var translate = (0, _useTranslations.default)();
  var singleDate = clickedDate || (Array.isArray(date) ? date[0] : date); // Ensures we are working with a JavaScript date object.

  var dateForViewMonth = (0, _utils.buildJSDate)(singleDate); // Dates are mutable. Ew...
  // Set the date to the first day of the month to avoid issues when navigating to february

  dateForViewMonth.setMonth(dateForViewMonth.getMonth() + monthOffset, 1);
  var setCurrentActiveDate = (0, _react.useCallback)(function (newCurrentActiveDate) {
    return function () {
      updateCalendarState({
        currentActiveDate: newCurrentActiveDate ? (0, _utils.buildJSDate)(newCurrentActiveDate) : undefined
      });
    };
  }, [updateCalendarState]);
  var setMonthOffset = (0, _react.useCallback)(function (newMonthOffset) {
    updateCalendarState({
      monthOffset: newMonthOffset
    });
  }, [updateCalendarState]);
  var setSelected = (0, _react.useCallback)(function (newSelected) {
    return function () {
      var newClickedDate = newSelected && (0, _utils.buildJSDate)(newSelected) || undefined;
      var newValue;

      if (options.variant === 'range') {
        var selectedDates = (0, _compact.default)(selected);
        if (selectedDates.length === 0 || selectedDates.length === 2) newValue = [newClickedDate];else {
          if ((0, _utils.isSameDate)(selectedDates[0], newClickedDate)) return;
          newValue = (0, _utils.sortSelectedDates)([selectedDates[0], newClickedDate]);
        }
      } else {
        newValue = newClickedDate && !(0, _utils.isSameDate)(newClickedDate, selected) ? newClickedDate : undefined;
      } // update only when is not being controlled


      if (!(0, _has.default)(options, 'selected')) {
        updateCalendarState({
          selected: newValue
        });
      }

      updateCalendarState({
        monthOffset: 0,
        clickedDate: newClickedDate
      });

      if (options.onChange) {
        options.onChange(newValue);
      }
    };
  }, [options, selected, updateCalendarState]);
  (0, _react.useEffect)(function () {
    if ((0, _has.default)(options, 'selected') && selected !== options.selected) {
      updateCalendarState({
        selected: options.selected
      });
    }
  }, [options, selected, updateCalendarState]);
  var viewNextMonth = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    setMonthOffset(monthOffset + 1);
  }, [setMonthOffset, monthOffset]);
  var viewPrevMonth = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    setMonthOffset(monthOffset - 1);
  }, [setMonthOffset, monthOffset]);
  var viewTodayMonth = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    var today = new Date();
    var dateForTodayMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    var diff = monthDiff((0, _utils.buildJSDate)(singleDate), dateForTodayMonth);
    setMonthOffset(diff);
  }, [setMonthOffset, singleDate]);

  var useMonthArg = _objectSpread({}, options, {
    currentActiveDate: currentActiveDate,
    date: dateForViewMonth,
    variant: options.variant || 'single',
    selected: selected
  });

  var _useMonth = (0, _useMonth2.default)(options.variant === 'single' ? useMonthArg : useMonthArg),
      displayMonth = _useMonth.displayMonth,
      dateMatrix = _useMonth.dateMatrix;

  return {
    currentActiveDate: currentActiveDate,
    displayMonth: displayMonth,
    dateMatrix: dateMatrix,
    label: translate(undefined, "calendar.month.".concat(displayMonth.month), {
      year: String(displayMonth.year)
    }),
    selected: selected,
    setCurrentActiveDate: setCurrentActiveDate,
    setSelected: setSelected,
    viewNextMonth: viewNextMonth,
    viewPrevMonth: viewPrevMonth,
    viewTodayMonth: viewTodayMonth
  };
}

var _default = useCalendar;
exports.default = _default;